module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }), _c('div', {
    staticClass: "title-frontMatter"
  }, [_vm._v("Publisher’s Preface")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The essays in this little volume, published here for the first time in book form, were written by Bertrand Russell during the second World War.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In those years the author was teaching philosophy at American universities, exercising a growing influence on America’s student population.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The essays assembled here are fundamentally concerned with “the art of reckoning” in the fields of mathematics, logic and philosophy.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The simplicity of Russell’s exposition is astonishing, as is his ability to get to the core of the great philosophical issues and to skillfully probe the depth of philosophical analysis.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63700eee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780806537351_fm01.vue
// module id = 69
// module chunks = 0